import API from "../utilities/LocalApiProxy";

export function searchBoxQuery({
	query,
	recentMatterIDs,
	limit,
	filterType,
	matterID,
}) {
	return API.post("/searchBox", {
		body: {
			query: query,
			recentMatterIDs: recentMatterIDs || [],
			limit,
			filterType,
			matterID,
		},
	});
}
